<div *ngIf="qanda.length == 0" class="mp-empty-profile font-t">
    Profile questions not answered yet.
</div>

<div *ngIf="qanda.length != 0">
    <div class="mp-profile-question-container" *ngFor="let section of sectionList">
        <h1 class="mp-section-header-text font-t">{{ section.text }}</h1>
        <div *ngFor="let qa of qanda; let i = index" class="mp-question-container">
            <div *ngIf="section.id == qa.section">
                <div class="mp-question-text font-t">{{ qa.question }}</div>
                <div class="mp-answer-text font-t"> {{ qa.answer }}</div>
            </div>
        </div>
    </div>
</div>
